import {
  Component,
  Input,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { AliveService } from '@ui/global-shared/services';
import { LoggedInUserChanged } from '@ui/global-shared/services/alive-service/alive.service';

@Component({
  selector: 'pt-multi-login-detected',
  templateUrl: './multi-login-detected.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [],
})
export class MultiLoginDetectedComponent {
  private aliveService = inject(AliveService);

  @Input() loggedInUserChanged: LoggedInUserChanged;
}
